import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { icon } from './resources'

const styles = (theme) => ({})

const ToolTip = withStyles(styles)(({ classes, iconWidth, ...rest }) => {
    return (
        <Tooltip {...rest}>
            <img width={iconWidth} src={icon} alt="" />
        </Tooltip>
    )
})

ToolTip.propTypes = {
    ...ToolTip.propTypes,
    iconWidth: PropTypes.string,
}

ToolTip.defaultProps = {
    ...ToolTip.defaultTypes,
    iconWidth: 'auto',
}

export default ToolTip
